const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

function headers() {
  return {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
    "Content-Type": "application/json",
  };
}

export interface FornoItem {
  id: number;
  displayId: number;
  orderId: number;
  descricao: string;
  observation: string | null;
  status: string;
  posicao: number;
  tempoMontagem: number | null;
  tempoForno: number | null;
  startedAt: string | null;
  finishedAt: string | null;
  createdAt: string;
  filaCreatedAt?: string | null;
  montagemStartedAt?: string | null;
  tamanho: { id: number; nome: string };
  borda: { id: number; nome: string } | null;
  responsavelNome: string | null;
  origem?: "cardapio" | "salao";
  salaoIdentificador?: string | null;
  salaoMesaId?: string | null;
  salaoComandaId?: string | null;
  pedidoIntegracao?: {
    orderType: string | null;
    observation: string | null;
    internalObservation?: string | null;
    customerName: string | null;
    statusIntegracao?: string | null;
  } | null;
  pedidoFoodfly?: {
    observacao: string | null;
  } | null;
}

export interface FornoListResponse {
  items: FornoItem[];
  total: number;
}

export const fornoService = {
  listar: async (lojaId?: number): Promise<FornoListResponse> => {
    const query = lojaId ? `?lojaId=${lojaId}` : "";
    const response = await fetch(`${API_URL}/fornos${query}`, {
      headers: headers(),
    });
    if (!response.ok) throw new Error("Erro ao buscar fila do forno");
    return response.json();
  },

  iniciar: async (id: number): Promise<FornoItem> => {
    const response = await fetch(`${API_URL}/fornos/${id}/iniciar`, {
      method: "POST",
      headers: headers(),
    });
    if (!response.ok) throw new Error("Erro ao iniciar item no forno");
    return response.json();
  },

  finalizar: async (id: number): Promise<FornoItem> => {
    const response = await fetch(`${API_URL}/fornos/${id}/finalizar`, {
      method: "POST",
      headers: headers(),
    });
    if (!response.ok) throw new Error("Erro ao finalizar item do forno");
    return response.json();
  },

  reordenar: async (id: number, posicao: number): Promise<FornoItem> => {
    const response = await fetch(`${API_URL}/fornos/${id}/reordenar`, {
      method: "PUT",
      headers: headers(),
      body: JSON.stringify({ posicao }),
    });
    if (!response.ok) throw new Error("Erro ao reordenar item");
    return response.json();
  },
};
